import React from 'react';
import styles from './index.module.scss';

const UnknownText = ({ contentData, contentText, contentName, imgName, imgsNames, videoName }) => {
  return (
    <div className={styles.unknownText}>
      <h2 className={styles.title}>Неизвестный Текст</h2>
      <p className={styles.description}>Компонент для неизвестного текста</p>
      {contentText && contentText !== 'none' && (
        <div className={styles.contentText}>
          <p>
            {contentText?.split('\n').map((line, lineIndex) => (
              <React.Fragment key={lineIndex}>
                {line}
                {lineIndex < contentText.split('\n').length - 1 && <br />}
              </React.Fragment>
            ))}
          </p>
        </div>
      )}
    </div>
  );
};

export default UnknownText;
